import React, { Fragment } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import styles from './verificationScreen.module.css';

import ScreenFrame from '../../components/ScreenFrame';
import Stepper from '../../components/Stepper';
import VerificationCard from '../../components/VerificationCard';
import {
    VERIFICATION_CARDS,
    VERIFICATION_DESCRIPTIONS,
    VERIFICATION_TITLE,
} from '../../helper/constants';

const VerificationScreen = ({ logo, cards, mode, stepLabel, steps }) => (
    <ScreenFrame
        logo={logo}
        title={VERIFICATION_TITLE}
        subTitle={stepLabel}
        showBack
        stepper={steps && <Stepper steps={steps} activeStep={1} />}
    >
        <Typography className={styles.description}>{VERIFICATION_DESCRIPTIONS[mode]}</Typography>
        {cards.map(({ type, attemptText }, index) => (
            <Fragment key={type}>
                {index > 0 && <Typography className={styles.separator}>{mode}</Typography>}
                <VerificationCard {...VERIFICATION_CARDS[type]} attemptText={attemptText} />
            </Fragment>
        ))}
    </ScreenFrame>
);

VerificationScreen.propTypes = {
    logo: PropTypes.string,
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string.isRequired,
            attemptText: PropTypes.string.isRequired,
        })
    ).isRequired,
    mode: PropTypes.string.isRequired,
    stepLabel: PropTypes.string.isRequired,
    steps: PropTypes.arrayOf(PropTypes.string),
};

export default VerificationScreen;
